import angular from "angular";
import * as  _ from "../externals/lodash";

export default angular.module("services.lodash",[]).factory("_",function () {
  return _;
}).name;



// WEBPACK FOOTER //
// ./src/ui/app/services/lodash.js